import { datadogRum } from '@datadog/browser-rum'
import { ReactElement, useEffect } from 'react'
import { Env } from 'constants/common'

type DataDogProps = {
  isDatadogEnabled: boolean
  children: ReactElement
}

const Datadog: React.FC<DataDogProps> = ({ isDatadogEnabled, children }) => {
  useEffect(() => {
    const applicationId = process.env.NEXT_PUBLIC_DATADOG_APP_ID
    const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN
    const initializeDatadog =
      isDatadogEnabled && !!applicationId && !!clientToken

    if (initializeDatadog) {
      datadogRum.init({
        applicationId,
        clientToken,
        site: 'datadoghq.com',
        service: 'thriveworks-web-service',
        env: process.env.VERCEL_GIT_COMMIT_REF ?? Env.DEV,
        version: '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 0,
        silentMultipleInit: true,
        trackResources: true,
        trackLongTasks: true,
        trackUserInteractions: true,
      })
    }
  }, [isDatadogEnabled])

  return children
}

export default Datadog
